// extracted by mini-css-extract-plugin
export default {"TemplateName":"DocumentTemplatesPopover_TemplateName__KqyVt"};